<template>
  <div id="form">
       <div class="form__margin">
            <div class="form__margin_title">
                <h3>Оставьте заявку мы вам перезвоним</h3>
            </div>
            <v-text-field class="inp" autocomplete="off" v-model.trim="nameUser" label="Имя" hide-details="auto"></v-text-field>
            <div class="error" v-if="$v.nameUser.$dirty && !$v.nameUser.required">Поле Имя обязателен к заполнению</div>

            <v-text-field class="inp" autocomplete="off" v-model.trim="phoneUser" label="Телефон" hide-details="auto"></v-text-field>
            <div class="error" v-if="$v.phoneUser.$dirty && !$v.phoneUser.required">Поле Телефон обязателен к заполнению</div>
            <div class="error" v-if="$v.phoneUser.$dirty && !$v.phoneUser.minLength">Поле телефон минимальная длина 11 цифр.</div>
            <div class="error" v-if="$v.phoneUser.$dirty && !$v.phoneUser.maxLength">Поле телефон максимальная длина 11 цифр.</div>
            <div class="error" v-if="$v.phoneUser.$dirty && !$v.phoneUser.numeric">Поле телефон введите только цифры</div>

            <v-text-field class="inp" autocomplete="off" v-model.trim="mailUser" label="Почта" hide-details="auto"></v-text-field>
            <div class="error" v-if="$v.mailUser.$dirty && !$v.mailUser.required">Поле Почта обязателен к заполнению</div>
            <div class="error" v-if="$v.mailUser.$dirty && !$v.mailUser.email">Некорректный email</div>

            <v-textarea
              solo
              v-model.trim="aboutUser"
              label="О себе"
              class="textarea"
              hide-details="auto"
              autocomplete="off"
            ></v-textarea>
            <div class="error" v-if="$v.aboutUser.$dirty && !$v.aboutUser.required">Поле О себе обязателен к заполнению</div>

            <v-btn class="btn" @click="sendDataUser" large color="primary">
                <span v-show="!viewLoader">
                    оставить заявку
                </span>
                <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate size="34"></v-progress-circular>
            </v-btn>
       </div>
  </div>
</template>
<script>
import axios from 'axios'
import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
    data: () => ({
       nameUser: '',
       mailUser: '',
       phoneUser: '',
       aboutUser: '',
       viewLoader: false
    }),
    validations: {
        nameUser: {
            required
        },
        mailUser: {
            required, email
        },
        phoneUser: {
            required, minLength: minLength(11), maxLength: maxLength(11), numeric
        },
        aboutUser: {
            required
        },
    },
    methods: {
      sendDataUser() {
          if (this.$v.$invalid) {
              this.$v.$touch()
              return 
          } else {
                this.viewLoader = true
                axios({
                    method: 'post',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    url: this.$apiURI + 'public/mail',
                    data: {
                        name: this.nameUser,
                        mail: this.mailUser,
                        phone: this.phoneUser,
                        about: this.aboutUser,
                    }
                })
                .then((response) => {
                    this.viewLoader = false
                    if (response.data.message == "ok") {
                        this.$toasted.show('Ваша заявка принята!').goAway(5000)
                        this.nameUser = ''
                        this.mailUser = ''
                        this.phoneUser = ''
                        this.aboutUser = ''
                    }
                })  
                .catch((error) => {
                    console.log(error);
                });
          }
      },
    }
  }
</script>
<style scoped lang="less">
@baseMedia: 900px;

#form {
    width: 100%;
    border-top: 1px solid #668800;
    padding-top: 20px;
    padding-bottom: 20px;

    .form__margin {
        width: 70%;
        margin: 0 auto;
        text-align: left;
        @media (max-width: @baseMedia) {
            width: 90%;
        }
        .error {
            color: red;
            font-size: 12px;
            margin-top: 5px;
        }
        .form__margin_title {
          width: 100%;
          text-align: center;
          h3 {
              font-size: 24px;
              text-transform: uppercase;
              color: #444;
              @media (max-width: @baseMedia) {
                  font-size: 18px;
              }
          }
        }
        
        .textarea {
            margin-top: 20px;
        }
        .inp {
            background: white;
            color: #5c6041;
        }
        .btn {
            width: 100%;
            background: #668800;
            margin-top: 20px;
            .loader__color {
              color: white;
            }
        }
    }
}
</style>
